const PreOrderListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'customer.customerName', // 预订单名称
            key:'business_order_name',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerPreOrder.businessOrderName',
        },
        {
            // name:'customer.customerType', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderName',
        },
        {
            // name:'customer.customerEmail', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderSource',
            options:[],
        },
        {
            // name:'customer.customerCountry', // 订单状态
            key:'business_order_status',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'order.orderStatus',
            optionToLocale:true,
            options:[
                {
                    label:'dealerPreOrder.ordered',
                    value:1
                },
                {
                    label:'dealerPreOrder.confirm',
                    value:3
                },
                {
                    label:'dealerPreOrder.cancel',
                    value:5
                }
            ]
        },
        {
            // name:'customer.customerCountry', // 信用额度验证
            key:'credit_validate',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerPreOrder.creditValidate',
            optionToLocale:true,
            options:[
                {
                    label:'dealerPreOrder.validateFail',
                    value:1
                },
                {
                    label:'dealerPreOrder.validateSuccess',
                    value:2
                },
            ]
        },
        {
            // name:'customer.customerCity', // 客户等级
            key:'customer_level',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'dealerPreOrder.customerLevel',
            optionToLocale:true,
            options:[
                {
                    label:'dealerPreOrder.bronze',
                    value:1
                },
                {
                    label:'dealerPreOrder.silver',
                    value:3
                },
                {
                    label:'dealerPreOrder.gold',
                    value:5
                },
                {
                    label:'dealerPreOrder.platinum',
                    value:5
                }
            ]
        },
        {
            // name:'customer.customerCity', // 国家
            key:'country',
            type:'select',   
            allowClear:true,
            width:'180px',
            placeholder:'order.country',
            options:[]
        },
    ]
}

const EditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'270px',
            placeholder:'order.orderSource',
            options:[]
        },
    ]
}

PreOrderListQuery.formField.forEach(item=>{
    PreOrderListQuery.formData[item.key] = ''
})

EditForm.formField.forEach(item=>{
    EditForm.formData[item.key] = ''
})

export {
    PreOrderListQuery,
    EditForm
}